<div class="duplicate-eca-modal">
 
  <!-- ================= HEADER ================= -->
  <div class="duplicate-eca-modal-header">
 
    <span class="duplicate-eca-title">
      Search product
    </span>
 
    <span
      class="close-icon"
      (click)="closeForm()"
    >
      <bh-icon
        icon="close"
        size="medium"
        color="white"
      ></bh-icon>
    </span>
 
  </div>
 

  <!-- ================= BODY ================= -->
  <div class="duplicate-eca-body">
 
    <!-- Serial Number Search -->
    <div class="serial-search-section">
 
      <div class="serial-input-wrapper">
 
        <label class="serial-label">
     <div class="d-flex">
     Enter serial number
     <span class="required">*</span>
     
     <span
     class="material-icons-outlined iconmaterial"
     (mouseenter)="showserialNOInfo = true"
     (mouseleave)="showserialNOInfo = false"
     >info</span>
    </div>
           <div *ngIf="showserialNOInfo" class="col-1 view-validation-info">
        <div class="dropdown set-position-serialNO-info p-0">
          <div class="breakdown-price">
            {{ 'rma-form.serialNumberInfoText' | cxTranslate }}
          </div>
        </div>
        </div>
        </label>
 
        <div class="serial-search-row">
 
          <div class="serial-input-container">
 
            <input
              type="text"
              class="serial-input"
              [(ngModel)]="serialNumber"
              placeholder="Enter serial number"
            />
 
            <span class="input-close"
            *ngIf="serialNumber"
            (click)="clearSerialNumber()"
            >×</span>
 
          </div>
 
          <bh-button
            type="primary"
            label="Search"
            (click)="searchForSerialNumberProduct()"
          >
          </bh-button>
 
        </div>
 
      </div>
 
    </div>
    
 
    <!-- ================= PRODUCT DETAILS ================= -->
    <ng-container *ngIf="filteredProduct && filteredProduct?.partNumber; else productNotFound">
    <div class="product-details-section">
      <div class="product-details-title">
        Confirm Product and Customer Details
      </div>
 
 
      <!-- TABLE -->
      <div class="product-table-wrapper">
 
        <table class="product-table">
 
          <thead>
            <tr>
              <th class="image-column"></th>
              <th>Serial Number</th>
              <th>Part Number</th>
              <th>Product Name &amp; Description</th>
              <th>Order #</th>
              <th>Sold To</th>
            </tr>
          </thead>
 
          <tbody>
 
  <tr>
 
    <td class="product-image-cell">
      <cx-media
      class="product-image"
     [container]="filteredProduct?.images"
      format="thumbnail"
      [alt]="filteredProduct?.images?.[0]?.altText"
      >
      </cx-media>
      
    </td>
 
    <!-- Serial Number -->
    <td>
      {{ filteredProduct?.serialNumber }}
    </td>
 
    <!-- Part Number -->
    <td>
      {{ filteredProduct?.partNumber }}
    </td>
 
    <!-- Product Name & Description -->
    <td class="product-description">
 
      <strong>
        {{ filteredProduct?.partDescription }}
      </strong>
 
     
 
    </td>
 
    <!-- Order Number -->
    <td>
      {{ filteredProduct?.orderId }}
    </td>
 
    <!-- Sold To -->
    <td class="sold-to">
 
      <strong>
        {{ filteredProduct?.soldToAddress }}
      </strong>
 
     
    </td>
 
  </tr>
 
</tbody>
 </table>
      </div>
 
 
      <!-- Not My Product -->
    </div>
    <div class="not-my-product">

      <span>
        Not my product
      </span>

      <a
      (click)="help()"
      >
        Connect me with customer support
      </a>

    </div>
</ng-container>
<ng-template #productNotFound>
  <div
    class="product-not-found"
    *ngIf="productNotFound"
  >
    <img
      src="../../../../assets/img/empty-box.svg"
      alt="No product found"
      class="product-not-found-icon"
    />
    <div class="product-not-found-title">
      We couldn't find your product
    </div>
    <div class="product-not-found-message">
      No product was found for the serial
      <br />
      number entered. Please check the
      <br />
      number and try again.
    </div>
    <div class="product-not-found-or">
      OR
    </div>
    <a
    
      class="product-contact-support"
      (click)="help()"
    >
      Contact us for further assistance
    </a>
  </div> 
</ng-template>
  <!-- ================= FOOTER ================= -->
  <div class="duplicate-eca-footer">
 
    <bh-button
      type="secondary"
      label="Cancel"
      (click)="closeForm()"
    >
    </bh-button>
    <bh-button
      type="primary"
      label="Confirm"
     [disabled]="!serialNumber?.trim() || !filteredProduct || !filteredProduct?.partNumber"
      [class.disabled]="!serialNumber?.trim() || !filteredProduct || !filteredProduct?.partNumber"
     (click)="confirmProduct()"
    >
    </bh-button>
  </div>
</div>